<template>
  <div class="funnel-diagram">
    <svg :width="calc_full_width" :height="full_height" :viewBox="view_box">
       <polygon v-for='(item, index) in polys' :points="item" :key="index" class="element" :class="{highlight: items[index].highlight}" />
       
       <ellipse :cx="calc_full_width/2" :cy="-full_height" :rx="calc_full_width/2" :ry="element_height/4" class="top-shadow" />
       <ellipse :cx="calc_full_width/2" :cy="0" :rx="bottom_width/2" :ry="element_height/4" class="bottom-shadow" />
       <!-- <polygon :points="points_overlay" class="overlay"/> -->
    </svg>
  </div>
</template>

<script>
import {computed} from "@vue/composition-api";

export default {
  name: "FunnelDiagram",
  props: {
    items:{
      type: Array,
      default: () => []
    },
    full_width:{
      type: Number,
      default: 120
    },
    bottom_width:{
      type: Number,
      default: 30
    },
    element_height:{
      type: Number,
      default: 14
    },
    gap:{
      type: Number,
      default: 7
    },

  },
  components: {
  },
  setup(props) {

    //set full_width depending on number of elements
    const calc_full_width = computed(() => {

      let limit = 5;
      if(props.items.length < limit)
      {
        return props.full_width * (100 - (limit - props.items.length) * 15) / 100;
      }

      return props.full_width;
    });

    const full_height = computed(() => calcY(props.items.length));
    
    const trapezoid_width = computed( () => (calc_full_width.value - props.bottom_width) / 2);

    const polys = computed( () => {
      let poly_arr = [];
      for(let i=1 ; i<=props.items.length ; i++)
      {
        poly_arr.push(calculatePoly(i));
      }
      return poly_arr;
    });

    const view_box = computed(() => '0 -' + (full_height.value + props.element_height/4) + ' ' + calc_full_width.value + ' ' + (full_height.value + props.element_height/2));

    const points_overlay = computed(() => {
      let tl = new Point(calc_full_width.value/2, -full_height.value-props.element_height/4);
      let tr = new Point(calc_full_width.value * 1.1, -full_height.value-props.element_height/4);
      let btm = new Point(calc_full_width.value/2, full_height.value);

      return tl + " " + tr + " " + btm;
    });

    function calculatePoly(n)
    {
      let y_top = calcY(n);
      let y_bottom = y_top - props.element_height;
      let additional_width = props.bottom_width + trapezoid_width.value;

      let tl = new Point(trapezoid_width.value - calcX(y_top), -y_top);

      let tr = new Point(calcX(y_top) + additional_width, -y_top);

      let br = new Point(calcX(y_bottom) + additional_width, -y_bottom);

      let bl = new Point(trapezoid_width.value - calcX(y_bottom), -y_bottom)

      return tl + ' ' + tr + ' ' + br + ' ' + bl;
    }

    function calcX(y){
      return y / full_height.value * trapezoid_width.value;
    }

    function calcY(n){
      let y = 0

      if(n > 0)
      {
        y = n * props.element_height + (n-1) * props.gap;
      }

      return y;
    }

    return {calculatePoly, full_height, polys, view_box, points_overlay, calc_full_width};
  }
}

class Point{
  constructor(x, y)
  {
    this.x = x;
    this.y = y;
  }
  toString(){
    return this.x + ',' + this.y;
  }
}

</script>

<style scoped lang="scss">
  .funnel-diagram{
    position: relative;
  
    svg{
      max-width: 100%;
      filter: drop-shadow(0rem 0.3rem 0.2rem rgba(0, 0, 0, 0.2));

      .element{
        fill: map-get($grey, 'lighten-4');
        
        &.highlight{
          fill: map-get($green, 'darken-1');
        }
      }
    
      .top-shadow{
        fill: #e0e0e0;
      }
      
      .bottom-shadow{
        fill:#72908b;
      } 
    
      .overlay{
        fill: #fff;
        fill-opacity: 50%;
      }
    }
  }

</style>
